import Details from '@/components/Details/Details';
import Tip from '@/components/Tip/Tip';
import IEventType from '@/types/IEventType';
import { Accordion, Button } from '@chakra-ui/react';
import { FaPlus } from 'react-icons/fa';
import { FcQuestions } from 'react-icons/fc';
import Question from './components/Question';
import useSectionQuestions from './useSectionQuestions';
export interface ISectionQuestionsProps {
	service: IEventType;
	onChange: (values: Partial<IEventType>) => void;
}

export default function SectionQuestions(props: ISectionQuestionsProps) {
	const { t, handleQuestionChange, handleAddQuestionClick, isLoading, handleDeleteClick } = useSectionQuestions({
		onChange: props.onChange,
		questions: props.service.questions,
	});

	return (
		<Details image={<FcQuestions />} title={t('Questions')}>
			<Tip>{t('Add questions to services to get additional data from the person making the reservation.')}</Tip>

			<Accordion allowToggle>
				{props.service.questions.map((q) => (
					<Question
						key={q.id}
						{...q}
						isLoading={isLoading}
						onChange={handleQuestionChange}
						onDelete={handleDeleteClick}
					/>
				))}
			</Accordion>

			<Button
				w="full"
				mt={2}
				size="sm"
				rightIcon={<FaPlus />}
				isLoading={isLoading}
				colorScheme="primary"
				onClick={handleAddQuestionClick}
			>
				{t('Add question')}
			</Button>
		</Details>
	);
}
